/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Invoice from '../../../functions/logic/Invoice'
import Spiner from '../../../components/Spiner'
import InvoiceGrid from '../../../components/DataGrid/InvoiceGrid'
import FormModalInvoice from '../../../components/FormModalInvoice'
import { useSnackbar } from 'notistack'

export default function Facturacion() {
    const [spiner, setSpiner] = useState(false)
    const [invoices, setInovices] = useState([])
    const param = useParams()
    const userToken = localStorage.getItem('userToken')
    const [isOpenModalform, setIsOpenModalForm] = useState(false)
    const [dataInvoice, setDataInvoice] = useState([])
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setSpiner(true)
        getUsersPendingInvoice(param)
        setSpiner(false)
    }, [param])

    const getUsersPendingInvoice = async (param) => {
        global.MENU_MODULE_SELECT = 'facturacion'
        const response = await Invoice.getPendingInvoiceLogic(userToken, localStorage.getItem('paramModule').replace(/"/g, ''), 0, 'P')
        setInovices(response["responseData"])
    }

    const handleSendInvoices = async () => {
        setSpiner(true)
        setSpiner(false)
        alert('Todas las facturas han sido enviadas al SRI.')
    }

    const handledVer = async (e) => {
        setSpiner(true)
        setIsOpenModalForm(true)
        const response = await Invoice.getPendingInvoiceLogic(userToken, localStorage.getItem('paramModule').replace(/"/g, ''), e)
        if(!response.responseResp.error) {
          setDataInvoice(response.responseData[0])
        }
        setSpiner(false)
    }

    const handledSend = async (e) => {
        setSpiner(true)
        const response = await Invoice.sentInvoiceToEmailLogic(userToken, localStorage.getItem('paramModule').replace(/"/g, ''), e)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setSpiner(false)
    }

    const handledSendSri = async () => {
        setSpiner(true)
        setSpiner(false)
        alert('Todas las facturas han sido enviadas al SRI.')
    }

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <FormModalInvoice
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={'Factura'}
                button={''}
                formData={dataInvoice}
                handledSave={[]}
                opt={'Factura'}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <button 
                                                onClick={handleSendInvoices} 
                                                className="btn btn-success mb-3"
                                            >
                                                Enviar todas las facturas al SRI
                                            </button>
                                            <InvoiceGrid
                                                rows={invoices}
                                                page={1}
                                                perPage={10}
                                                header={invoices}
                                                handledVer={handledVer} 
                                                handledSend={handledSend}
                                                handledSendSri={handledSendSri}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
